import { memo, useState } from "react";
import downIcon from "../assets/img/Desktop/Meteor_component_9_D.png";
import upIcon from "../assets/img/Desktop/Meteor_component_8_D.png";
import MaxWidthLayout from "./MaxWidthLayout";

const questionData = [
  {
    index: 1,
    title: "如何成為Meteor學生社群會員？",
    content: (
      <>
        <p className="pb-16px">
          下載Meteor後，上傳學生證審核通過後及成為Meteor會員。
        </p>
        <p>Meteor下載連結：</p>
        <p>
          電腦版：
          <a
            href="https://meteor.today/register"
            className="text-green-1 underline"
          >
            https://meteor.today/register
          </a>
        </p>
        <p>
          iOS：
          <a href="https://reurl.cc/Q3Nrz0" className="text-green-1 underline">
            https://reurl.cc/Q3Nrz0
          </a>
        </p>
        <p>
          Android：
          <a href="https://reurl.cc/OqQZyX" className="text-green-1 underline">
            https://reurl.cc/OqQZyX
          </a>
        </p>
      </>
    ),
  },
  {
    index: 2,
    title: "什麼是Meteor學生社群？",
    content: (
      <>
        <p>
          Meteor是專屬於學生的社群論壇，開放國中生、高中生、大學生及碩士生註冊，讓同學們在Meteor瀏覽、討論、追蹤各類熱門話題，從課業、升學、感情、至社團生活，各式各樣的話題都能盡情討論。
        </p>
      </>
    ),
  },
  {
    index: 3,
    title: "今年即將升高一 (國三應屆畢業生) 是否可以申請？",
    content: (
      <>
        <p>可以。請提供國三的整學年成績及高一的在學證明。</p>
      </>
    ),
  },

  {
    index: 4,
    title: "今年即將升大一 (高三應屆畢業生) 是否可以申請？",
    content: (
      <>
        <p>可以。請提供高三的整學年成績及大一的在學證明。</p>
      </>
    ),
  },
  {
    index: 5,
    title: "五專的學生是否可以申請?",
    content: (
      <>
        <p>可以。</p>
      </>
    ),
  },
  {
    index: 6,
    title: "本獎學金申請資格需為中華民國國民嗎？",
    content: (
      <>
        <p>
          米特獎學金申請資格為中華民國國民。僑生與外國學生不符合米特獎學金的申請資格。
        </p>
      </>
    ),
  },
];

const Accordion = ({ index, title, content, length }) => {
  const [answerShow, setAnswerShow] = useState(false);
  return (
    <li
      className={` text-28px border-b border-solid border-black-20% last:border-none ${
        index > 1 ? "pt-24px" : ""
      } `}
    >
      <div className="flex">
        <h3 className="text-lg md:text-28px md:leading-normal text-green-1 font-semibold pr-21px">
          Q{index}
        </h3>
        <div className="flex-1">
          <div
            className={`flex justify-between ${
              index !== length || answerShow ? "pb-16px md:pb-24px" : ""
            }`}
            onClick={() => {
              setAnswerShow(!answerShow);
            }}
          >
            <h3 className="text-lg md:text-28px md:leading-normal text-green-1 font-semibold">
              {title}
            </h3>
            <div className="flex items-center h-28px md:h-42px min-w-13px md:min-w-17px ml-19px">
              <img
                src={`${answerShow ? upIcon : downIcon}`}
                alt="下按鈕"
                className="w-13px md:w-17px"
              />
            </div>
          </div>
          {answerShow && (
            <div
              className={`text-xl hidden md:block ${
                index !== length ? "pb-32px" : ""
              }`}
            >
              {content}
            </div>
          )}
        </div>
      </div>

      {answerShow && (
        <div
          className={`text-14px  block md:hidden ${
            index !== length ? "pb-24px " : ""
          }`}
        >
          {content}
        </div>
      )}
    </li>
  );
};

const CommonQuestion = () => {
  return (
    <MaxWidthLayout>
      <div id="commonQuestion" className="pt-64px md:pt-112px">
        <h2 className="text-26px md:text-4xl text-green-1 font-semibold text-center pb-16px md:pb-40px">
          常見問題
        </h2>
        <ul className="border border-solid border-black rounded-15px md:rounded-30px py-24px md:py-40px px-22px md:px-54px w-90% md:w-80% max-w-828px m-auto bg-white text-black-1">
          {questionData.map((data) => (
            <Accordion
              key={data.index}
              title={data.title}
              content={data.content}
              index={data.index}
              length={questionData.length}
            />
          ))}
        </ul>
      </div>
    </MaxWidthLayout>
  );
};

export default memo(CommonQuestion);
